"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constant2 = _interopRequireDefault(require("lodash/fp/constant"));

var _prop2 = _interopRequireDefault(require("lodash/fp/prop"));

var _serverError = require("../actions/server-error");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var deserialize = function (response) {
  var header = response.headers.get('Content-Type') || '';

  if (header.indexOf('application/json') > -1) {
    return response.json();
  }

  if (header.indexOf('application/octet-stream') > -1) {
    return response.arrayBuffer();
  }

  return response.text();
};

var _default = function _default(_a) {
  var fetch = _a.fetch,
      globalApiDomain = _a.apiDomain,
      _b = _a.getDefaultHeader,
      getDefaultHeader = _b === void 0 ? (0, _constant2.default)({}) : _b;
  return function (_a) {
    var getState = _a.getState,
        dispatch = _a.dispatch;
    return function (next) {
      return function (action) {
        return __awaiter(void 0, void 0, void 0, function () {
          var payload, meta, url, isApi, withoutAuth, apiDomain, headers, others, response, data;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                payload = action.payload, meta = action.meta;
                if (!payload) return [3
                /*break*/
                , 3];
                url = payload.url, isApi = payload.isApi, withoutAuth = payload.withoutAuth, apiDomain = payload.apiDomain, headers = payload.headers, others = __rest(payload, ["url", "isApi", "withoutAuth", "apiDomain", "headers"]);
                if (!isApi) return [3
                /*break*/
                , 3];
                return [4
                /*yield*/
                , fetch("" + (apiDomain || globalApiDomain) + url, __assign(__assign({}, others), {
                  credentials: 'same-origin',
                  headers: __assign(__assign({}, getDefaultHeader({
                    getState: getState,
                    withoutAuth: withoutAuth
                  })), headers)
                }))];

              case 1:
                response = _a.sent();
                return [4
                /*yield*/
                , deserialize(response)];

              case 2:
                data = _a.sent();

                if (response.status >= 200 && response.status < 300) {
                  next(__assign(__assign({}, action), {
                    payload: data
                  }));
                  return [2
                  /*return*/
                  , data];
                }

                dispatch((0, _serverError.throwServerError)(data, {
                  status: response.status,
                  statusText: response.statusText,
                  ignoreGlobalWarning: (0, _prop2.default)('ignoreGlobalWarning')(meta),
                  ignoreAuthRedirection: (0, _prop2.default)('ignoreAuthRedirection')(meta),
                  originalAction: action
                }));
                throw data;

              case 3:
                return [2
                /*return*/
                , next(action)];
            }
          });
        });
      };
    };
  };
};

exports.default = _default;